<template>
    <div
        id="quoteModal"
        ref="quoteModal"
        class="modal quote-modal"
        role="dialog"
        aria-label="Quote"
    >
        <div class="modal-container">
            <div class="modal-header">
                <div class="container">
                    <div class="logo">
                        <a href="/">
                            <logo />
                        </a>
                    </div>

                    <h2 class="sr-only">Quote</h2>

                    <button
                        ref="closeBtn"
                        type="button"
                        class="close-button"
                        @click.prevent="close"
                    >
                        <span
                            class="i icons8-close-button"
                            aria-hidden="true"
                        />

                        <span>Close</span>
                    </button>
                </div>
            </div>

            <div
                id="modal-content"
                ref="modalBody"
                class="modal-body"
            >
                <div class="container">
                    <h2
                        id="quote-form-title"
                        class="quote-form-title"
                    >
                        Request a quote
                    </h2>

                    <p class="intro">
                        Our team will endevour to get back to you within one working day.
                    </p>

                    <hub-spot-contact-form id="hubSpotQuoteForm" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Logo from '../svgs/Logo';
    import HubSpotContactForm from '../HubSpotContactForm';

    export default {
        name: 'quote-form',

        components: {
            Logo,
            HubSpotContactForm,
        },

        data() {
            return {
                originalFocusEl: null,
            };
        },

        mounted() {
            this.$bus.$on('quoteForm', () => {
                // remember what triggered modal so can go back to it on close
                this.originalFocusEl = document.activeElement;

                this.openModal();

                // stop other content from being focusable
                const els = document.querySelectorAll('.non-quote-modal');
                els.forEach((el) => {
                    el.setAttribute('tabIndex', '-1');
                    el.classList.add('hidden');
                });
            });
        },

        methods: {
            /**
             * Opens the quote form
             */
            openModal() {
                $(this.$refs.quoteModal).modal('show');

                if (window.fullpage_api) {
                    window.fullpage_api.setAutoScrolling(false);
                }

                this.scrollTopModal();
            },

            /**
             * Closes the quote form
             */
            close() {
                $(this.$refs.quoteModal).modal('hide');

                // allow other content to be focusable
                const els = document.querySelectorAll('.non-quote-modal');

                els.forEach((el) => {
                    el.removeAttribute('tabIndex');

                    el.classList.remove('hidden');
                });

                // put focus back to element that triggered modal
                this.originalFocusEl.focus();
            },

            /**
             * Scroll/focus to top of modal.
             */
            scrollTopModal() {
                const el = this.$refs.closeBtn;

                if (!el) {
                    return;
                }

                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });

                el.focus({
                    preventScroll: true,
                });
            },

            /**
             * Scroll/focus to top of next form step.
             */
            scrollTop() {
                const el = this.$refs.modalBody;

                if (!el) {
                    return;
                }

                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });

                el.setAttribute('tabIndex', '-1');

                el.focus({
                    preventScroll: true,
                });

                document.activeElement.blur();
            },
        },
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/vendor/bootstrap/variables";
    @import (reference) "../../../../../node_modules/bootstrap/less/mixins/grid";
    @import (reference) "~assets/less/mixins/rem";

    .quote-modal {
        position: fixed;
        z-index: @zindex-modal;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: #ffffff;
    }

    .modal-container {
        display: flex;
        flex-direction: column;
        position: fixed;
        z-index: @zindex-modal;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }

    .modal-header {
        padding: 20px 0;
        position: relative;
        z-index: 2;
        .container {
            display: flex;
            align-items: center;
        }
    }
    .close-button {
        color: @secondary-colour;
        font-family: futura-pt, sans-serif;
        .rem-font-size(12px);
        font-weight: 500;
        text-transform: uppercase;
        .rem-letter-spacing(1.39px);
        text-align: center;
        display: block;
        margin-left: auto;
        line-height: 1;
        text-decoration: none;
        opacity: 0.21;
        border: 0;
        background-color: transparent;

        &:hover,
        &:focus,
        &:active {
            opacity: 0.8;
        }

        span {
            display: block;
        }
        .i {
            .rem-font-size(35px);
            &,
            &:before {
                line-height: inherit;
                display: block;
            }
        }
    }

    .logo {
        margin-right: auto;

        a {
            display: block;

            &:hover,
            &:focus,
            &:active {
                text-decoration: none;
            }
        }
    }

    .modal-body {
        flex-grow: 1;
        overflow: auto;
        padding: 0;
        top: 50px;
    }

    .quote-form-title {
        color: @secondary-colour;
        .rem-font-size(40px);
        font-weight: 500;
        .rem-letter-spacing(-0.03px);
        @media (min-width: @screen-sm-min) {
            .rem-font-size(50px);
        }
    }

    .intro {
        max-width: 550px;
    }

    .hub-spot-contact-form-container {
        padding-top: 20px;
    }
</style>
